import React, { Component } from 'react';
import {Button} from 'semantic-ui-react';
import '../../assets/css/home.css';
import Banner from "../../widget/PageBanner";
import ListOfTours from './ListOfTours.js';
import dividerRight from '../../assets/images/divider-right.png';
import headerBorder from '../../assets/images/line-orange.png';
import {Redirect} from 'react-router';

export default class Tour extends Component {

	state = { 
		redirect: false,
		routeLink: ''
	};

	componentDidMount = () =>{
		window.scrollTo(0, 0);
		sessionStorage.setItem('openModal', false);
	}

	goToContactUs = () => {
		this.setState({
			redirect: true,
			routeLink: '/contactus'
		});
	}

  render() {
	const {redirect, routeLink} = this.state;
		
    return (
		<div>	
			{ redirect &&
				<Redirect push to={routeLink}/>
			}
			<div className="half-banner-wrapper">
				<Banner pagename="Tours"/>
			</div>
			
			<div className="section-content-wrapper margin-top-5">
				<h1 className="section-header align-center">Tour packages</h1>
				<div className="align-center"><img src={headerBorder} className="header-border align-center" alt="" /></div>
				<p className="para-content">
					See the best of the world with our unique selection of organized tours, carefully designed for all types of travelers.
				</p>
				
				<ListOfTours/>
			</div>

			<div className="divider-wrapper-right margin-top-2">
				<img src={dividerRight} className="divider-right" alt="Plane divider" />
			</div>

			<div className="section-content-wrapper margin-top-5">
				<h1 className="section-header align-center">Personalize your tours</h1>
				<p className="para-content">
					Make your adventure feel a little more personal. With our private tour option, you can sign up for one of our tours, customize it, and bring along only people you choose. 
				</p>

				<div className="align-center"><Button color='orange' onClick={this.goToContactUs}>Inquire now</Button></div>
			</div>
			
		</div>
    );
  }
}
